import { render, staticRenderFns } from "./SeasonalChristmasNavigation.vue?vue&type=template&id=2b2b50c7&scoped=true"
import script from "./SeasonalChristmasNavigation.vue?vue&type=script&lang=ts"
export * from "./SeasonalChristmasNavigation.vue?vue&type=script&lang=ts"
import style0 from "./SeasonalChristmasNavigation.vue?vue&type=style&index=0&id=2b2b50c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b50c7",
  null
  
)

export default component.exports